import React from "react";
import { IconButton, Pane } from "@folio/stripes/components";
import { useIntl } from "react-intl";
export var DataListPane = function (_a) {
    var paneId = _a.paneId, paneTitle = _a.paneTitle, paneSub = _a.paneSub, filterPaneIsVisible = _a.filterPaneIsVisible, toggleFilterPane = _a.toggleFilterPane, children = _a.children;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(Pane, { id: paneId, defaultWidth: filterPaneIsVisible ? "fill" : "100%", paneTitle: paneTitle, paneSub: paneSub, firstMenu: !filterPaneIsVisible && (React.createElement(IconButton, { icon: "caret-right", onClick: toggleFilterPane, "aria-label": formatMessage({ id: "ui-br-publishers.filter.show" }), style: { marginLeft: "auto" } })) }, children));
};
